//* 부고 검색 입력줄 — 결과 표(SellerFeventSearchTable)와 떨어져 배치할 수 있게 분리했다.
//* 검색어는 recoil atom으로 전달되므로 표는 이 컴포넌트 위치와 무관하게 동작한다.
import { FC, useEffect, useState } from 'react';

import { useRecoilState } from 'recoil';

import { sellerFeventAppliedearchValueAtom } from '@service/seller/containers/SellerFeventSearchTable/state/sellerFeventSearchTable.atom';
import { Button } from '@shared/components/Button';
import { Icon } from '@shared/components/icons';
import { TextField } from '@shared/components/TextField';

export const SellerFeventSearchBar: FC = function SellerFeventSearchBar() {
  const [searchValue, setSearchValue] = useState<string>('');
  const [appliedearchValue, setAppliedSearchValue] = useRecoilState(
    sellerFeventAppliedearchValueAtom,
  );
  const { MagnifyingGlassRegular } = Icon();

  //* 전화주문 요청 목록·번호검색 결과의 '찾기'가 검색어를 넣으면 입력칸도 따라간다
  useEffect(() => {
    setSearchValue(appliedearchValue);
  }, [appliedearchValue]);

  return (
    <div className="space-y-3">
      <p className="w-full">부고를 검색하여 전화주문을 완성하세요</p>
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <TextField
            className="w-full"
            placeholder="부고검색(고인/상주/장례식장)"
            type="search"
            value={searchValue}
            onChange={(event) => {
              setSearchValue(event.currentTarget.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                setAppliedSearchValue(searchValue);
              }
            }}
          />
          <Button
            className="center-box shrink-0 gap-2"
            onClick={() => {
              setAppliedSearchValue(searchValue);
            }}
          >
            <MagnifyingGlassRegular className="wh-4" />
            <p>검색</p>
          </Button>
        </div>
        <p className="break-keep text-xs text-gray-500">
          고인·상주·장례식장·상조 이름으로 검색합니다.
        </p>
      </div>
    </div>
  );
};
